import type { Metadata } from 'next';

const LCV_METATAG = {
  title: 'อีซูซุประเทศไทย Isuzu Thailand Official',
  description:
    'ดูข้อมูลรถ ISUZU D-Max และ MU-X คำนวณค่างวด เปรียบเทียบรุ่นรถ ขอสินเชื่อ ดูข้อเสนอพิเศษต่างๆ พร้อมทั้งดาวน์โหลดโบรชัวร์ ทั้งรถกระบะ และ SUV และค้นหาศูนย์บริการใกล้บ้านท่าน',
  url: 'https://www.isuzu-tis.com/',
  image: 'https://assets.isuzu-tis.com/og_isuzu_official_d70d6878ac.jpg',
} as const;

export const LCV_METADATA: Metadata = {
  title: LCV_METATAG.title,
  description: LCV_METATAG.description,
  openGraph: {
    title: LCV_METATAG.title,
    description: LCV_METATAG.description,
    url: LCV_METATAG.url,
    images: [
      {
        url: LCV_METATAG.image,
        width: 1200,
        height: 630,
      },
    ],
  },
  alternates: {
    canonical: LCV_METATAG.url,
  },
};
